(function() {
    "use strict";

    const ko = require('knockout');
    const $ = require('jquery');
    const koQuill = require('../components/ko.quill');

    class ChapterViewModel {
        constructor(data) {
            this.id = data.id;
            this.roleplay = data.roleplay;
            this.posts = ko.observableArray([]);
            this.title = ko.observable(data.title || '');
            this.description = ko.observable(data.description || '{}');
            this.author = ko.observable(data.author || {});
            this.nextCharacter = ko.observable(data.nextCharacter || {});
            this.postId = ko.observable(data.postId || false);
            this.post = ko.observable(data.post || '{}');
            this.characters = ko.observableArray([]);
        }

        load() {
            if (this.id) {
                $.ajax('/api/search/posts?chapter=' + this.id, {
                    method: 'get',
                    success: data => {
                        this.posts(data);
                    }
                });

                $.ajax('/api/search/characters?chapter=' + this.id, {
                    method: 'get',
                    success: data => {
                        this.characters(data);
                    }
                });
            }
        }

        save() {
            if (this.postId()) {
                $.ajax('/api/post', {
                    method: 'put',
                    data: {
                        id: this.postId(),
                        text: this.post(),
                        chapter: this.id
                    },
                    success: data => {
                        if (data.success) {
                            window.location.reload();
                        }
                    }
                });
            } else {
                $.ajax('/api/post', {
                    method: 'post',
                    data: {
                        text: this.post(),
                        chapter: this.id
                    },
                    success: data => {
                        if (data.success) {
                            window.location.reload();
                        }
                    }
                });
            }
        }

        skip() {
            $.ajax('/api/post', {
                method: 'post',
                data: {
                    chapter: this.id,
                    action: 'skip'
                },
                success: data => {
                    if (data.success) {
                        window.location.reload();
                    }
                }
            });
        }
    }

    module.exports = ChapterViewModel;
})();


// WEBPACK FOOTER //
// ./resources/scripts/viewmodels/chapterViewModel.js